import addFilterCounts from './add-filter-counts';

/**
 * Given an array of grants from the knight-foundation-app/v1/grants endpoint,
 * optionally filtered, converts them into an array of filters based on facets
 * found within the grants.
 * @param {Array} grants - The grants array to convert into an array of filters.
 * @returns {Array} An array of filters.
 */
const filtersFromGrants = (grants) => addFilterCounts(grants
  .reduce((acc, item) => {
    const {
      communities = [],
      programs = [],
      started_on: startedOn = '',
    } = item;

    // Add programs.
    programs.forEach(({ name }) => {
      acc[0].options.push({
        label: name,
        value: name,
      });
    });

    // Add start date.
    if ('' !== startedOn) {
      const year = startedOn.substring(0, 4);
      acc[1].options.push({
        label: year,
        value: year,
      });
    }

    // Add communities.
    communities.forEach((community) => {
      acc[2].options.push({
        label: community,
        value: community,
      });
    });

    return acc;
  }, [{
    label: 'Programs',
    options: [],
    type: 'program-areas',
  },
  {
    label: 'Year Granted',
    options: [],
    type: 'years',
  },
  {
    label: 'Communities',
    options: [],
    type: 'communities',
  }]));

export default filtersFromGrants;
